module.exports = __webpack_public_path__ + "static/media/playstore.ea248014.png";